import { defineMessages } from "react-intl";

const messages = defineMessages({
  title: {
    id: "AppointmentReport.AppointmentReportResendDialog.title",
    defaultMessage: "Resend Reports",
  },
  message: {
    id: "AppointmentReport.AppointmentReportResendDialog.message",
    defaultMessage: "All reports for this appointment will be resent to",
  },
  at: {
    id: "AppointmentReport.AppointmentReportResendDialog.at",
    defaultMessage: "at",
  },
  btnCancel: {
    id: "AppointmentReport.AppointmentReportResendDialog.btnCancel",
    defaultMessage: "Cancel",
  },
  btnSubmit: {
    id: "AppointmentReport.AppointmentReportResendDialog.btnSubmit",
    defaultMessage: "Resend Reports",
  },
});

export default messages;
